import {
  NUMBER_ONLY_REGEX,
  NUMBER_WITH_DECIMAL_REGEX,
} from "@portal/util/regex";
import { useCallback } from "react";
import { CustomRange, CustomRangeValidation } from "../../type";

type NumericValidationProps = {
  allowDecimal?: boolean;
};
export const customFieldRange = ["from", "to"] as const;
export function useNumericRangeValidation(props: NumericValidationProps) {
  const regex = props.allowDecimal
    ? NUMBER_WITH_DECIMAL_REGEX
    : NUMBER_ONLY_REGEX;
  const validationText = props.allowDecimal
    ? "Value should be a number"
    : "Decimal values are not allowed";
  function handleFromValidation(
    value: number | null,
    rangeValues: CustomRange<typeof customFieldRange>
  ): CustomRangeValidation {
    if (!value && value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "Value should not be empty",
      };
    } else if (!regex.test(value as unknown as string)) {
      return {
        validateStatus: "error",
        errorMsg: validationText,
      };
    } else if (!regex.test(rangeValues.to.value as unknown as string)) {
      return {
        validateStatus: "error",
        errorMsg: `${validationText} in 'To field'`,
      };
    } else if (!rangeValues.to.value && rangeValues.to.value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "'To' Value should not be empty",
      };
    } else if (value > rangeValues.to.value || value === rangeValues.to.value) {
      return {
        validateStatus: "error",
        errorMsg: "'From' Value should be less than 'To' value",
      };
    } else {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
  }
  function handleToValidation(
    value: number | null,
    rangeValues: CustomRange<typeof customFieldRange>
  ): CustomRangeValidation {
    if (!value && value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "Value should not be empty",
      };
    } else if (!regex.test(value as unknown as string)) {
      return {
        validateStatus: "error",
        errorMsg: validationText,
      };
    } else if (!regex.test(rangeValues.from.value as unknown as string)) {
      return {
        validateStatus: "error",
        errorMsg: `${validationText} in 'From field'`,
      };
    } else if (!rangeValues.from.value && rangeValues.from.value !== 0) {
      return {
        validateStatus: "error",
        errorMsg: "'From' value should not be empty",
      };
    } else if (
      value < rangeValues.from.value ||
      value === rangeValues.from.value
    ) {
      return {
        validateStatus: "error",
        errorMsg: "'To' value should be greater than 'From' value",
      };
    } else {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
  }
  const formValidation = useCallback(handleFromValidation, [
    regex,
    validationText,
  ]);
  const toValidation = useCallback(handleToValidation, [regex, validationText]);
  return { formValidation, toValidation };
}
